@let mode = this.activeMode();

<div class="cam-cal" [class]="'cam-cal--' + mode">
  @switch (mode) {
    @case ('month') {
      <div class="cam-cal__month">
        <div class="cam-cal__monthhead">
          @for (label of this.weekdayLabels(); track label) {
            <div class="cam-cal__monthheadcell">{{ label }}</div>
          }
        </div>
        @for (week of this.monthWeeks(); track $index) {
          <div class="cam-cal__monthweek">
            @for (cell of week; track cell.key) {
              <div
                class="cam-cal__day cam-cal__monthcell"
                data-allday="true"
                [attr.data-date]="cell.iso"
                [class.is-other]="cell.isOtherMonth"
                [class.is-today]="cell.isToday"
              >
                <span class="cam-cal__monthnumber" (click)="this.selectDay(cell.date)">{{ cell.number }}</span>
                <div class="cam-cal__monthevents">
                  @for (box of cell.events; track box.key) {
                    <div
                      class="b-cal-event {{ box.cls }}"
                      [style.--cal-event-color]="box.color"
                      (pointerdown)="this.onEventPointerDown($event, box, 'move')"
                    >
                      <div class="b-cal-event-body">
                        <div class="b-event-header">{{ box.record.getName() }}</div>
                        <div class="b-cal-event-desc" [camRenderedContent]="box.content"></div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    }

    @case ('year') {
      <div class="cam-cal__year">
        @for (month of this.yearMonths(); track month.key) {
          <div class="cam-cal__yearmonth">
            <div class="cam-cal__yearlabel">{{ month.label }}</div>
            <div class="cam-cal__yeargrid">
              @for (label of this.weekdayLabels(); track label) {
                <span class="cam-cal__yearweekday">{{ label }}</span>
              }
              @for (cell of month.cells; track cell.key) {
                <span
                  class="cam-cal__yearday"
                  [class.has-events]="cell.hasEvents"
                  [class.is-other]="cell.isOtherMonth"
                  [class.is-today]="cell.isToday"
                  (click)="this.selectDay(cell.date)"
                  >{{ cell.number }}</span
                >
              }
            </div>
          </div>
        }
      </div>
    }

    @default {
      <div class="cam-cal__timegrid">
        <div class="cam-cal__head">
          <div class="cam-cal__gutter"></div>
          @for (column of this.dayColumns(); track column.key) {
            <div class="cam-cal__headcell" [class.is-today]="column.isToday">
              <span class="cam-cal__weekday">{{ column.weekday }}</span>
              <span class="cam-cal__daylabel">{{ column.label }}</span>
            </div>
          }
        </div>

        @if (this.hasAllDayRow()) {
          <div class="cam-cal__allday">
            <div class="cam-cal__gutter"></div>
            @for (column of this.dayColumns(); track column.key) {
              <div class="cam-cal__day cam-cal__day--allday" data-allday="true" [attr.data-date]="column.iso">
                @for (box of column.allDayEvents; track box.key) {
                  <div
                    class="b-cal-event {{ box.cls }}"
                    [style.--cal-event-color]="box.color"
                    (pointerdown)="this.onEventPointerDown($event, box, 'move')"
                  >
                    <div class="b-cal-event-body">
                      <div class="b-event-header">{{ box.record.getName() }}</div>
                      <div class="b-cal-event-desc" [camRenderedContent]="box.content"></div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }

        <div class="cam-cal__scroller">
          <div class="cam-cal__body" [style.height.px]="this.gridHeight()">
            <div class="cam-cal__gutter">
              @for (hourLabel of this.hourLabels(); track hourLabel.hour) {
                <div class="cam-cal__hour" [style.height.px]="this.hourHeight()">
                  <span>{{ hourLabel.label }}</span>
                </div>
              }
            </div>

            @for (column of this.dayColumns(); track column.key) {
              <div class="cam-cal__day" [attr.data-date]="column.iso" [class.is-today]="column.isToday">
                @for (hour of this.hours(); track hour) {
                  <div class="cam-cal__slot" [style.height.px]="this.hourHeight()"></div>
                }

                @for (range of column.timeRanges; track range.key) {
                  <div
                    class="b-cal-timerange {{ range.cls }}"
                    [style.height.px]="range.height"
                    [style.top.px]="range.top"
                  >
                    @if (this.timeRangeHeaderWidth()) {
                      <div class="b-cal-timerange-header" [style.width.px]="this.timeRangeHeaderWidth()">
                        {{ range.name }}
                      </div>
                    }
                    <div class="b-cal-timerange-body"></div>
                  </div>
                }

                @if (column.isToday && this.nowIndicator() !== null) {
                  <div class="cam-cal__now" [style.top.px]="this.nowIndicator()"></div>
                }

                @for (box of column.events; track box.key) {
                  <div
                    class="b-cal-event {{ box.cls }}"
                    [style.--cal-event-color]="box.color"
                    [style.height.px]="box.height"
                    [style.left.%]="box.left"
                    [style.top.px]="box.top"
                    [style.width.%]="box.width"
                    (pointerdown)="this.onEventPointerDown($event, box, 'move')"
                  >
                    <div class="b-cal-event-body">
                      <div class="b-event-header">{{ box.record.getName() }}</div>
                      <div class="b-cal-event-desc" [camRenderedContent]="box.content"></div>
                    </div>
                    <div class="cam-cal__resize" (pointerdown)="this.onEventPointerDown($event, box, 'resize')"></div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
  }
</div>
